import { makeStyles } from "@material-ui/core";
import React, { useMemo } from "react";

import { HelpVideo } from "../../../enums/helpVideo";
import { useAuth } from "../../../features/auth/context";
import { useFullSitesLoader } from "../../../hooks/useFullSitesLoader";
import { useOrgSiteContext } from "../../../hooks/useOrgSiteContext";
import { PageHeader } from "../../PageHeader";
import { OrgSelect } from "../../shared/OrgSelect";

import { ServerStatus } from "./ServerStatus";
import { SiteInfo } from "./SiteInfo";
import { SiteIssues } from "./SiteIssues";
import { SitesStats } from "./SitesStats";
import { ReportsLink } from "./ReportsLink";
import { SitesInMaintenanceModeWidget } from "./SitesInMaintenanceModeWidget";

const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
    },
}));

export function HomePage() {
    const {
        isGlobalAdmin,
        isDealerAdmin,
        isDealerEmployee,
        isOrgAdmin,
        isOrgEmployee,
        isSiteAdmin,
        isSiteEmployee,
    } = useAuth();

    const deassocciateSiteFromContext = isOrgAdmin || isOrgEmployee || isSiteAdmin || isSiteEmployee;

    const assignedOrgAndSite = useAuth();
    const {
        dealerId: contextDealerId,
        orgId: contextOrgId,
        siteId: contextSiteId,
        siteChangeCallback,
    } = useOrgSiteContext("home");

    const dealerId = useMemo(
        () => contextDealerId || assignedOrgAndSite.dealerId,
        [assignedOrgAndSite.dealerId, contextDealerId]
    );
    const orgId = useMemo(
        () => contextOrgId || assignedOrgAndSite.orgId,
        [assignedOrgAndSite.orgId, contextOrgId]
    );
    const siteId = useMemo(
        () => contextSiteId || assignedOrgAndSite.siteId,
        [contextSiteId, assignedOrgAndSite.siteId]
    );

    const { sites, loading } = useFullSitesLoader({ dealerId, siteId, orgId });

    const classes = useStyles();

    return (
        <>
            <PageHeader
                helpVideoNum={HelpVideo.Login}
                isLoading={loading}
            >
                Home Page
            </PageHeader>

            <ServerStatus />

            <OrgSelect
                dealerSelectIsEnabled={isGlobalAdmin}
                orgSelectIsEnabled={isGlobalAdmin || isDealerAdmin || isDealerEmployee}
                selectedDealerId={dealerId || null}
                selectedOrgId={orgId || null}
                selectedSiteId={siteId || null}
                onChange={(val: {
                    dealerId?: number | null;
                    orgId?: number | null;
                    siteId?: number | null;
                }) => siteChangeCallback(val.dealerId, val.orgId, val.siteId)}
                bypassSiteContext={deassocciateSiteFromContext}
            />

            <div className={classes.container}>
                <SitesInMaintenanceModeWidget
                    dealerId={dealerId}
                    orgId={orgId}
                    siteId={siteId}
                />

                {sites.length > 1 && (
                    <SitesStats sites={sites} dealerId={dealerId} />
                )}

                {sites.length === 1 && (
                    <>
                        <SiteInfo site={sites[0]} dealerId={dealerId} />
                        <SiteIssues site={sites[0]} />
                    </>
                )}

                <ReportsLink
                    dealerId={dealerId}
                    orgId={orgId}
                    siteId={siteId}
                />
            </div>
        </>
    );
};